/**
 * Helpers for the `/call` route params.
 *
 * expo-router hands every param over as a string (or string[]), so anything
 * numeric has to be parsed back before it reaches a JSON body.
 */

/**
 * Parses the `phone_id` route param into the number the token endpoint expects.
 *
 * Returns `undefined` — so the field is *omitted* from the request, never sent
 * as `NaN`, `"undefined"` or `null` — for an absent/empty param, the literal
 * strings `"undefined"` / `"null"`, or anything that isn't a positive integer.
 */
export function parsePhoneIdParam(raw: string | string[] | undefined | null): number | undefined {
    const value = Array.isArray(raw) ? raw[0] : raw;
    if (value == null) return undefined;
    const trimmed = String(value).trim();
    if (!/^\d+$/.test(trimmed)) return undefined;
    const parsed = Number(trimmed);
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : undefined;
}
